@if (enableAiQuery) {
  <!-- Floating Chat Button -->
  <ix-icon-button
    class="glow-button"
    [class.hidden]="expanded()"
    oval
    icon="ai"
    size="24"
    onkeydown=""
    (click)="onChatButtonClick()"
    variant="subtle-primary">
  </ix-icon-button>

  <!-- Chat Pane -->
  <ix-pane
    class="ai-chatbot-pane"
    [heading]="'ai_chatbot.heading' | translate"
    icon="ai"
    variant="floating"
    [hideOnCollapse]="true"
    size="600px"
    [expanded]="expanded()"
    (expandedChanged)="expandedChanged($event)">
    <!-- Header Buttons -->
    <div class="header-buttons">
      <ix-icon-button
        class="me-2"
        icon="trashcan"
        size="24"
        onkeydown=""
        (click)="clearChat()"
        variant="subtle-tertiary">
      </ix-icon-button>
    </div>

    <!-- Pane Content: Full Height Flex Container -->
    <div class="d-flex flex-column h-100">
    <!-- Messages Area: Takes remaining space, scrollable -->
    <div class="flex-grow-1 overflow-auto" #messageContainer>
      <!-- Welcome Screen -->
      @if (messages().length === 0 && !isLoading()) {
        <div class="welcome-screen">
          <ix-typography
            [bold]="true"
            format="display"
            id="welcomeMessage">
            {{
              userFirstName
                ? ('ai_chatbot.welcome.greeting' | translate: {name: userFirstName})
                : ('ai_chatbot.welcome.greeting_anonymous' | translate)
            }}
          </ix-typography>

          <ix-typography
            format="display"
            id="welcomeQuestion">
            {{ 'ai_chatbot.welcome.question' | translate }}
          </ix-typography>

          <ix-card
            class="example-card mb-2"
            variant="filled"
            onkeydown=""
            (click)="askExampleQuestion('ai_chatbot.example_questions.question_1')">
            <ix-card-content>
              {{ 'ai_chatbot.example_questions.question_1' | translate }}
            </ix-card-content>
          </ix-card>

          <ix-card
            class="example-card"
            variant="filled"
            onkeydown=""
            (click)="askExampleQuestion('ai_chatbot.example_questions.question_2')">
            <ix-card-content>
              {{ 'ai_chatbot.example_questions.question_2' | translate }}
            </ix-card-content>
          </ix-card>
        </div>
      }

      @for (message of messages(); track message.id) {
        <div class="mb-3 d-flex gap-2" [class.flex-row-reverse]="message.isUser">
          <!-- Avatar -->
          @if (message.isUser) {
            <div class="avatar user-avatar flex-shrink-0">
              {{ userInitials }}
            </div>
          } @else {
            <div class="avatar ai-avatar flex-shrink-0">
              <ix-icon name="ai" size="16"></ix-icon>
            </div>
          }

          <!-- Message Content -->
          <div class="d-flex flex-column" [class.align-items-end]="message.isUser">
            <div
              class="d-inline-block"
              [class.user-message]="message.isUser"
              [class.ai-message]="!message.isUser">
              {{ message.content }}
            </div>

            <!-- References -->
            @if (message.references && message.references.length > 0) {
              <div class="d-flex flex-wrap gap-1 mt-2">
                @for (reference of message.references; track reference) {
                  <ix-pill
                    variant="neutral"
                    icon="pdf-document"
                    class="me-3"
                    [tooltipText]="'ai_chatbot.message.tooltip' | translate:{documentName: reference}">
                    <span class="reference-text">{{ reference }}</span>
                  </ix-pill>
                }
              </div>
            }

            <div class="message-timestamp mt-1">{{ message.timestamp | date:'short' }}</div>
          </div>
        </div>
      }

      @if (isLoading()) {
        <div class="mb-3 d-flex gap-2">
          <div class="avatar ai-avatar flex-shrink-0">
            <ix-icon name="ai" size="16"></ix-icon>
          </div>
          <div class="ai-message typing-indicator">
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
          </div>
        </div>
      }
    </div>

    <!-- Input Area: Fixed at bottom -->
    <div class="d-flex gap-2 py-3 align-items-center">
      <ix-textarea
        [(ngModel)]="messageText"
        [placeholder]="'ai_chatbot.input.placeholder' | translate"
        resize-behavior="none"
        [textareaWidth]="'100%'"
        (keydown)="onEnterKey($event)"
        class="flex-grow-1">
      </ix-textarea>
      <ix-icon-button
        icon="arrow-up"
        [disabled]="!messageText.trim() || isLoading()"
        (click)="sendMessage()"
        onkeydown=""
        oval
        variant="subtle-primary">
      </ix-icon-button>
    </div>

    <!-- AI Disclaimer -->
    <div class="text-center pb-2">
      <ix-typography
        format="label-sm"
        text-color="soft"
        [innerHTML]="'ai_chatbot.disclaimer' | translate">
      </ix-typography>
    </div>
  </div>
</ix-pane>
}

